module.exports = {
  SHIPPING: 'shipping',
  RETURNING: 'returning',
  OTHER: 'other',
};
